(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/rules/assets/javascripts/rules/system.js') >= 0) return;  svs.modules.push('/components/numbergames/rules/assets/javascripts/rules/system.js');

'use strict';

let Factorial;
if (svs.isServer) {
  const trinidadCore = require('@svenskaspelab/trinidad-core').core;
  Factorial = trinidadCore.components.require('utils', 'math').api.Factorial;
} else {
  Factorial = svs.utils.math.Factorial;
}

function generatedRows(_ref) {
  let _ref$numbersLength = _ref.numbersLength,
    numbersLength = _ref$numbersLength === void 0 ? 0 : _ref$numbersLength,
    _ref$numbersExtraLeng = _ref.numbersExtraLength,
    numbersExtraLength = _ref$numbersExtraLeng === void 0 ? 0 : _ref$numbersExtraLeng,
    _ref$numbersRowSize = _ref.numbersRowSize,
    numbersRowSize = _ref$numbersRowSize === void 0 ? 0 : _ref$numbersRowSize,
    _ref$numbersExtraRowS = _ref.numbersExtraRowSize,
    numbersExtraRowSize = _ref$numbersExtraRowS === void 0 ? 0 : _ref$numbersExtraRowS;
  if (numbersLength < numbersRowSize || numbersExtraLength < numbersExtraRowSize) return 0;
  if (numbersLength === numbersRowSize && numbersExtraLength === numbersExtraRowSize) return 1;
  const calculateCombinations = (selectedLength, rowLength) => {
    let numberOfCombinations = Factorial(selectedLength);
    numberOfCombinations /= Factorial(selectedLength - rowLength);
    numberOfCombinations /= Factorial(rowLength);
    return numberOfCombinations;
  };
  const numbersCombinations = calculateCombinations(numbersLength, numbersRowSize);
  const numbersExtraCombinations = calculateCombinations(numbersExtraLength, numbersExtraRowSize);
  return numbersCombinations * numbersExtraCombinations;
}

function systemNumbersLimits(_ref2) {
  let rules = _ref2.rules,
    combinationSize = _ref2.combinationSize,
    level = _ref2.level;
  const NUMBERS = rules.SYSTEM.LIMITS.NUMBERS;
  const numberCombination = combinationSize || level;
  if (NUMBERS) {
    return {
      min: NUMBERS.combinationMinLength[numberCombination] || NUMBERS.minRowLength,
      max: NUMBERS.combinationMaxLength[numberCombination] || NUMBERS.maxRowLength
    };
  }
  return {};
}

function systemNumbersExtraLimits(_ref3) {
  let rules = _ref3.rules,
    combinationSize = _ref3.combinationSize;
  const NUMBERS_EXTRA = rules.SYSTEM.LIMITS.NUMBERS_EXTRA;
  if (NUMBERS_EXTRA) {
    return {
      min: NUMBERS_EXTRA.combinationMinLength[combinationSize] || NUMBERS_EXTRA.minRowLength,
      max: NUMBERS_EXTRA.combinationMaxLength[combinationSize] || NUMBERS_EXTRA.maxRowLength
    };
  }
  return {};
}

function systemLimits(_ref4) {
  let rules = _ref4.rules,
    numberSize = _ref4.numberSize,
    numberExtraSize = _ref4.numberExtraSize,
    level = _ref4.level;
  return {
    numbersLimits: systemNumbersLimits({
      rules,
      combinationSize: numberExtraSize,
      level
    }),
    numbersExtraLimits: systemNumbersExtraLimits({
      rules,
      combinationSize: numberSize
    })
  };
}
function systemName(_ref5) {
  let numbersLength = _ref5.numbersLength,
    numbersExtraLength = _ref5.numbersExtraLength,
    level = _ref5.level;
  if (numbersExtraLength) {
    return "System ".concat(numbersLength, " + ").concat(numbersExtraLength);
  }
  if (level) {
    return "System Keno ".concat(level, " | ").concat(numbersLength, " nummer");
  }
  return "System ".concat(numbersLength);
}
function systemDescription(_ref6) {
  let numbersLength = _ref6.numbersLength,
    numbersExtraLength = _ref6.numbersExtraLength,
    level = _ref6.level,
    rowCount = _ref6.rowCount;
  if (rowCount > 1) {
    return "".concat(systemName({
      numbersLength,
      numbersExtraLength,
      level
    }), ": ").concat(rowCount, " rader");
  }
  return 'System';
}
if (svs.isServer) {
  module.exports = {
    generatedRows,
    systemNumbersLimits,
    systemNumbersExtraLimits,
    systemLimits,
    systemName,
    systemDescription
  };
} else {
  svs.numbergames.rules.system = {
    generatedRows,
    systemNumbersLimits,
    systemNumbersExtraLimits,
    systemLimits,
    systemName,
    systemDescription
  };
}

 })(window);